import React from "react";
import { SUCCESS } from "LIB/submission";

export default function dataManager(propName, api, initialState = null) {
  return Component =>
    class extends React.Component {
      state = {
        loading: false,
        result: initialState
      };

      componentWillMount() {
        this.load();
      }

      load = () => {
        this.setState({ loading: true });

        return api(this.props).then(result => {
          this.setState({
            loading: false,
            result
          });

          return SUCCESS;
        });
      };

      save = result => this.setState({ result });

      componentProps() {
        const { loading, result } = this.state;

        return {
          ...this.props,
          loading,
          [propName]: result
        };
      }

      render() {
        return (
          <Component
            {...this.componentProps()}
            reload={this.load}
            refresh={this.load}
            save={this.save}
          />
        );
      }
    };
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/dataManager.jsx